import EnumService from '../EnumService'

export default class SituacaoFormaPagamentoService extends EnumService{

    constructor(){
        super('enumSituacaoFormaPagamento');
    }
  
  }